import { render, staticRenderFns } from "./AlertaProcessoModal.vue?vue&type=template&id=2a7e2326&scoped=true"
import script from "./AlertaProcessoModal.vue?vue&type=script&lang=js"
export * from "./AlertaProcessoModal.vue?vue&type=script&lang=js"
import style0 from "./AlertaProcessoModal.vue?vue&type=style&index=0&id=2a7e2326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e2326",
  null
  
)

export default component.exports